// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"19":"css/admin-app.7091","1482":"css/app.7091"}[chunkId] + ".css";
};